'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var cn = require('classnames');
var consts = require('../../consts.js');
var components_checkmark_Component = require('../checkmark/Component.js');
var components_checkmarkMobile_Component = require('../checkmark-mobile/Component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var styles = {"option":"select__option_13w27","disabled":"select__disabled_13w27","size-48":"select__size-48_13w27","size-56":"select__size-56_13w27","size-64":"select__size-64_13w27","size-72":"select__size-72_13w27","selected":"select__selected_13w27","highlighted":"select__highlighted_13w27","content":"select__content_13w27","textContent":"select__textContent_13w27"};
require('./index.css')

var Option = function (_a) {
    var _b, _c;
    var _d = _a.size, size = _d === void 0 ? 48 : _d, className = _a.className, option = _a.option, children = _a.children, selected = _a.selected, highlighted = _a.highlighted, disabled = _a.disabled, multiple = _a.multiple, mobile = _a.mobile, _e = _a.Checkmark, Checkmark = _e === void 0 ? mobile ? components_checkmarkMobile_Component.Checkmark : components_checkmark_Component.Checkmark : _e, innerProps = _a.innerProps, dataTestId = _a.dataTestId;
    var content = children || option.content || option.key;
    var _f = option.showCheckMark, showCheckMark = _f === void 0 ? true : _f;
    return (React__default.default.createElement("div", tslib.__assign({}, innerProps, { className: cn__default.default(styles.option, styles[consts.SIZE_TO_CLASSNAME_MAP[size]], className, (_b = {},
            _b[styles.highlighted] = !mobile && highlighted,
            _b[styles.selected] = selected,
            _b[styles.disabled] = disabled,
            _b)), "data-test-id": dataTestId }),
        Checkmark && showCheckMark && (React__default.default.createElement(Checkmark, { disabled: disabled, selected: selected, multiple: multiple, position: 'before' })),
        React__default.default.createElement("div", { className: cn__default.default(styles.content, (_c = {},
                _c[styles.textContent] = !React.isValidElement(content),
                _c)) }, content),
        Checkmark && showCheckMark && (React__default.default.createElement(Checkmark, { disabled: disabled, selected: selected, multiple: multiple, position: 'after' }))));
};

exports.Option = Option;
